var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinutes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 79,
    viewBox: "0 0 115 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.1447 1.26758H59.6514V3.80052H62.1447V1.26758Z",
    fill: "#06C5AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2111 1.26758H34.7178V3.80052H37.2111V1.26758Z",
    fill: "#06C5AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1975 1.26758H39.7041V3.80052H42.1975V1.26758Z",
    fill: "#06C5AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1848 1.26758H44.6914V3.80052H47.1848V1.26758Z",
    fill: "#06C5AC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1711 1.26758H49.6777V3.80052H52.1711V1.26758Z",
    fill: "#06C5AC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1579 1.26758H54.6646V3.80052H57.1579V1.26758Z",
    fill: "#06C5AC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2243 6.33105H29.731V8.864H32.2243V6.33105Z",
    fill: "#06C5AC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2243 11.4014H29.731V13.9343H32.2243V11.4014Z",
    fill: "#06C5AC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2243 16.4651H29.731V18.998H32.2243V16.4651Z",
    fill: "#06C5AC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2243 21.5286H29.731V24.0615H32.2243V21.5286Z",
    fill: "#06C5AC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0643 27.4564L86.8203 34.6753L89.189 35.4352L91.433 28.2163L89.0643 27.4564Z",
    fill: "#06C5AC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3117 0H90.8184V5.06588H93.3117V0Z",
    fill: "#06C5AC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3117 10.1338H90.8184V15.1997H93.3117V10.1338Z",
    fill: "#06C5AC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5453 6.33105H94.5586V8.864H99.5453V6.33105Z",
    fill: "#06C5AC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5717 6.33105H84.585V8.864H89.5717V6.33105Z",
    fill: "#06C5AC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3517 69.6546H38.4578C37.4659 69.6546 36.5146 69.2543 35.8132 68.5418C35.1118 67.8292 34.7178 66.8629 34.7178 65.8552V10.1305C34.7178 9.1228 35.1118 8.15642 35.8132 7.44389C36.5146 6.73137 37.4659 6.33105 38.4578 6.33105H78.3517C79.3436 6.33105 80.2949 6.73137 80.9963 7.44389C81.6977 8.15642 82.0917 9.1228 82.0917 10.1305V22.5166H79.5983V10.1305C79.5983 9.79458 79.467 9.47247 79.2332 9.23496C78.9994 8.99745 78.6823 8.864 78.3517 8.864H38.4578C38.1272 8.864 37.8101 8.99745 37.5763 9.23496C37.3425 9.47247 37.2111 9.79458 37.2111 10.1305V65.8552C37.2111 66.1911 37.3425 66.5132 37.5763 66.7507C37.8101 66.9882 38.1272 67.1217 38.4578 67.1217H78.3517C78.6823 67.1217 78.9994 66.9882 79.2332 66.7507C79.467 66.5132 79.5983 66.1911 79.5983 65.8552V40.5258H82.0917V65.8552C82.0917 66.8629 81.6977 67.8292 80.9963 68.5418C80.2949 69.2543 79.3436 69.6546 78.3517 69.6546Z",
    fill: "#06C5AC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0915 35.4651H79.5981V37.998H82.0915V35.4651Z",
    fill: "#06C5AC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2243 26.5989H29.731V29.1318H32.2243V26.5989Z",
    fill: "#06C5AC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2243 31.6624H29.731V34.1953H32.2243V31.6624Z",
    fill: "#06C5AC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2243 36.726H29.731V39.2589H32.2243V36.726Z",
    fill: "#06C5AC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2243 41.7961H29.731V44.3291H32.2243V41.7961Z",
    fill: "#06C5AC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2243 46.8597H29.731V49.3927H32.2243V46.8597Z",
    fill: "#06C5AC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2243 1.26758H29.731V3.80052H32.2243V1.26758Z",
    fill: "#06C5AC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1576 12.6624H40.9507V15.1953H57.1576V12.6624Z",
    fill: "#06C5AC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1447 12.6624H59.6514V15.1953H62.1447V12.6624Z",
    fill: "#06C5AC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1315 12.6624H64.6382V15.1953H67.1315V12.6624Z",
    fill: "#06C5AC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6647 18.9934H40.9512V21.5264H54.6647V18.9934Z",
    fill: "#06C5AC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3123 35.463C92.8133 35.4635 92.3173 35.3866 91.8412 35.235L65.4489 26.9903L60.0508 19.5054L68.4285 17.3145L94.7833 25.5592C95.9219 25.9184 96.8962 26.6802 97.5294 27.7064C98.1627 28.7326 98.4131 29.9553 98.2352 31.153C98.0573 32.3506 97.4629 33.4438 96.5598 34.2345C95.6566 35.0252 94.5045 35.461 93.3123 35.463ZM66.9699 24.8119L92.5767 32.816C92.8149 32.8912 93.0629 32.9296 93.3123 32.93C93.9084 32.9291 94.4845 32.7112 94.936 32.3158C95.3876 31.9205 95.6848 31.3738 95.7737 30.775C95.8627 30.1762 95.7375 29.5648 95.4209 29.0517C95.1042 28.5386 94.6171 28.1577 94.0478 27.9781L68.3786 19.9487L64.2396 21.0252L66.9699 24.8119Z",
    fill: "#06C5AC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8716 43.0571H45.938V45.5901H70.8716V43.0571Z",
    fill: "#06C5AC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3639 63.3216H68.3771C67.7159 63.3216 67.0817 63.0548 66.6141 62.5797C66.1465 62.1047 65.8838 61.4605 65.8838 60.7887V56.9893H68.3771V60.7887H73.3639V50.4416C73.2874 50.0441 73.1114 49.6733 72.8527 49.3651C71.606 47.5794 69.8607 45.0591 69.8607 45.0591L69.7235 44.8691L69.6612 44.6285C69.6612 44.6285 68.4145 39.4107 67.8286 37.3336C67.7257 37.1332 67.5664 36.9684 67.3711 36.8601C67.1757 36.7519 66.9531 36.7051 66.7315 36.7257H50.0758C49.8532 36.708 49.6302 36.7574 49.4351 36.8678C49.2399 36.9782 49.0812 37.1446 48.9788 37.3463C48.4178 39.3093 47.1586 44.5652 47.1461 44.6285V44.8565L46.9965 45.0591C46.9965 45.0591 45.2263 47.5921 44.0045 49.3651C43.7414 49.6704 43.5647 50.0424 43.4934 50.4416V60.7887H48.4801C48.4801 60.7887 48.4801 60.7127 48.4801 60.5734V56.9893H50.9735V60.5734C51.0029 60.9236 50.9602 61.2763 50.8481 61.6089C50.7361 61.9415 50.5571 62.2468 50.3225 62.5053C50.088 62.7638 49.8031 62.9699 49.4859 63.1104C49.1687 63.251 48.8262 63.3229 48.4801 63.3216H43.4934C42.8321 63.3216 42.1979 63.0548 41.7303 62.5797C41.2627 62.1047 41 61.4605 41 60.7887V50.4416C41.0453 49.517 41.3769 48.6305 41.9475 47.9086C42.9697 46.4142 44.4408 44.4132 44.8273 43.78C45.0891 42.7035 46.074 38.4228 46.635 36.6244C46.8827 35.8911 47.3556 35.2579 47.9839 34.8179C48.6123 34.378 49.363 34.1544 50.1257 34.1801H66.7814C67.5465 34.1512 68.3002 34.3749 68.9296 34.8179C69.5589 35.2609 70.03 35.8992 70.2721 36.6371C70.7957 38.5241 71.818 42.7161 72.0673 43.7673C72.5161 44.4005 73.9373 46.4142 74.9596 47.9213C75.5317 48.6423 75.8635 49.5293 75.9071 50.4543V60.7887C75.9072 61.1256 75.8411 61.4592 75.7127 61.7698C75.5842 62.0805 75.3961 62.362 75.1593 62.5979C74.9224 62.8338 74.6416 63.0193 74.3333 63.1436C74.0251 63.2678 73.6955 63.3284 73.3639 63.3216Z",
    fill: "#06C5AC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6115 55.7261H42.1978V58.259H74.6115V55.7261Z",
    fill: "#06C5AC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1845 50.6625H42.1978V53.1954H47.1845V50.6625Z",
    fill: "#06C5AC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6117 50.6625H69.625V53.1954H74.6117V50.6625Z",
    fill: "#06C5AC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8979 50.6625H55.9111V53.1954H60.8979V50.6625Z",
    fill: "#06C5AC"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    cx: 57.3387,
    cy: 69.6559,
    rx: 57.3387,
    ry: 9.34409,
    fill: "#06AEAA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinutes);
export default __webpack_public_path__ + "static/media/Minutes.fce038373bbbe01ace859185ad47760d.svg";
export { ForwardRef as ReactComponent };